import { CustomError } from "@skv/core";

export interface State {
  opportunities: {
    [oppId: string]: string | number;
  };
  organisations: {
    [orgId: string]: string | number;
  };
  loading: boolean;
  error: false | null | CustomError;
}

export enum FAVOURITES_ENUM {
  OPPORTUNITY = "opp",
  ORGANISATION = "org",
}

export type ActionTypes =
  | {
      type: "FAVOURITES:FETCH:START";
    }
  | {
      type: "FAVOURITES:FETCH:END";
      payload: {
        opportunities: {
          [oppId: string]: string;
        };
        organisations: {
          [orgId: string]: string;
        };
      };
    }
  | {
      type: "FAVOURITES:OPP:ADD";
      payload: {
        id: string;
      };
    }
  | {
      type: "FAVOURITES:ORG:ADD";
      payload: {
        id: string;
      };
    }
  | {
      type: "FAVOURITES:OPP:REMOVE";
      payload: {
        id: string;
      };
    }
  | {
      type: "FAVOURITES:ORG:REMOVE";
      payload: {
        id: string;
      };
    };
